// A document short enough to read whole and awkward enough to be worth reading: a field with the delimiter inside
// it, a field with a doubled quote in it, and a column of numbers the grid can be sorted by.
export const SAMPLE_DOCUMENT = `id,name,category,price,in stock
1,"Cable, USB-C",Accessories,12.50,true
2,Keyboard,Peripherals,89.00,true
3,"27"" Monitor",Displays,329.99,false
4,Mouse,Peripherals,24.95,true
5,"Dock, Thunderbolt",Accessories,199.00,false
`;
